
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import ArticleInfoCover from '@root/modules/article/components/info/ArticleInfoCover.vue';

interface Props {
  article: ArticleData;
}
interface Computed {
  title: string;
  subtitle: string;
}
export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    ArticleInfoCover,
  },
  props: {
    article: {
      required: true,
    },
  },
  computed: {
    title() {
      return this.article.content.title.html.replace(/(<\/?h1>)/gi, '');
    },
    subtitle() {
      return this.article.content.subtitle.text || String(this.$t('words.live'));
    },
  },
});
